import { propertyCustomerRoleLabels } from "../../../../../../../../../_shared/_logic/customer-roles"
import type { CustomerFilterValue } from "../customers-table-contract"

export const customerTypeOptions = [
  { name: "Alle Typen", value: "" },
  { name: "Privatperson", value: "PERSON" },
  { name: "Unternehmen", value: "COMPANY" },
]

export const contactDataOptions = [
  { name: "Alle Kontaktdaten", value: "" },
  { name: "Keine Kontaktdaten", value: "NONE" },
  { name: "Nur E-Mail", value: "EMAIL_ONLY" },
  { name: "Nur Telefonnummer", value: "PHONE_ONLY" },
  { name: "Nur Adresse", value: "ADDRESS_ONLY" },
  { name: "Adresse vorhanden", value: "HAS_ADDRESS" },
  { name: "E-Mail und Telefonnummer", value: "BOTH" },
]

export const roleOptions = [
  { name: "Alle Verbindungsrollen", value: "" },
  { name: propertyCustomerRoleLabels.OWNER, value: "OWNER" },
  { name: propertyCustomerRoleLabels.TENANT, value: "TENANT" },
  { name: propertyCustomerRoleLabels.MANAGER, value: "MANAGER" },
  { name: propertyCustomerRoleLabels.BILLING_CONTACT, value: "BILLING_CONTACT" },
  { name: propertyCustomerRoleLabels.OTHER, value: "OTHER" },
]

export const createDefaultCustomerFilters = (): CustomerFilterValue => ({
  query: "",
  customerType: "",
  contactData: "",
  propertyId: "",
  role: "",
  archiveScope: "ACTIVE",
})

const normalizeCustomerFilterValue = (value: string): string => value.trim()

export const buildCustomerFilterRefreshKey = (filters: CustomerFilterValue): string =>
  JSON.stringify({
    query: normalizeCustomerFilterValue(filters.query),
    customerType: normalizeCustomerFilterValue(filters.customerType),
    contactData: normalizeCustomerFilterValue(filters.contactData),
    propertyId: normalizeCustomerFilterValue(filters.propertyId),
    role: normalizeCustomerFilterValue(filters.role),
    archiveScope: filters.archiveScope,
  })
